import { useState } from "react";
import * as React from "react";
import { useDeleteProductGroup } from "~/apps/pos/apis/productGroups";
import { ProductSegment } from "~/apps/pos/models";
import { DeleteConfirmOverlay } from "~/apps/pos/admin/components/shared/DeleteConfirmOverlay";

export const useProductGroupDeleteConfirm = () => {
  const [deleteItem, setDeleteItem] = useState<ProductSegment | undefined>(undefined);
  const { mutate: onDelete, isLoading, error } = useDeleteProductGroup();

  const handleClose = () => setDeleteItem(undefined);

  const handleDelete = () => {
    if (!deleteItem?.id) return;
    onDelete(deleteItem.id, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const deleteConfirm = deleteItem ? (
    <DeleteConfirmOverlay
      headTitle={"Delete group!"}
      itemName={deleteItem.name}
      isLoading={isLoading}
      error={error?.message || error?.errorMessage || ""}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  ) : null;

  return {
    deleteConfirm,
    showDeleteConfirm: setDeleteItem,
  };
};
